export const store = {
  state: {
    games: {},
    gamesMap: {},
    balance: 0.00,
    logoUrl: '',
    currency: '',
    email: '',
    userName: '',
    isOnline: false,
    isGameInProgress: false,
    isAutoPlay: true,
    isVideoAllowed: true,
    isPauseAllowed: true,
    isFullscreenAllowed: false,
    config: {},
    gameName: ''
  },
  setGames (games) {
    if (games) {
      this.state.games = games
      this.setBalance(games.balance / 100)
      this.setCurrency(games.currency)
      this.setEmail(games.email)
      this.setUsername(games.userName)
      games.games.forEach(element => {
        this.state.gamesMap[element.gameName] = element
      })
    }
  },
  setGameName (gameName) {
    this.gameName = gameName
  },
  getGameName () {
    return this.gameName
  },
  setLogoUrl (logoUrl) {
    this.state.logoUrl = logoUrl
  },
  getLogoUrl () {
    return this.state.logoUrl
  },
  setFullscreenAllowed (isFullscreenAllowed) {
    this.state.isFullscreenAllowed = isFullscreenAllowed
  },
  isFullscreenAllowed () {
    return this.state.isFullscreenAllowed
  },
  setPauseAllowed (isPauseAllowed) {
    this.state.isPauseAllowed = isPauseAllowed ? true : isPauseAllowed
  },
  isPauseAllowed () {
    return this.state.isPauseAllowed
  },
  setVideoAllowed (isVideoAllowed) {
    this.state.isVideoAllowed = isVideoAllowed ? true : isVideoAllowed
  },
  isVideoAllowed () {
    return this.state.isVideoAllowed
  },
  setAutoPlay (isAutoPlay) {
    this.state.isAutoPlay = isAutoPlay ? true : isAutoPlay
  },
  isAutoPlayEnabled () {
    return this.state.isAutoPlay
  },
  setGameInProgress (gameInProgress) {
    this.state.isGameInProgress = gameInProgress
  },
  setBalance (balance) {
    if (!isNaN(balance)) {
      this.state.balance = balance
    }
  },
  getBalance () {
    return this.state.balance
  },
  setEmail (email) {
    this.state.email = email
  },
  getEmail () {
    return this.state.email
  },
  setUsername (userName) {
    this.state.userName = userName
  },
  getUsername () {
    return this.state.userName
  },
  setOnline (isOnline) {
    this.state.isOnline = isOnline
  },
  isOnline () {
    return this.state.isOnlinea
  },
  setCurrency (currency) {
    if (currency) {
      this.state.currency = currency
    }
  },
  getCurrency () {
    return this.state.currency
  },
  getGames () {
    return this.state.games
  },
  getGamesMap () {
    return this.state.gamesMap
  },
  getOperator () {
    return 'user'
  },
  isGameInProgress () {
    return this.state.isGameInProgress
  },
  isGameSwitcherVisible () {
    return this.state.games.games.length > 1
  },
  getTokenByGameName (gameName) {
    let game = this.getGamesMap()[gameName]
    if (game) {
      return game.token
    }
  },
  getUrlByGameName (gameName) {
    let game = this.getGamesMap()[gameName]
    if (game) {
      return game.endpoint
    }
  },
  setConfig (config) {
    if (config) {
      this.state.config = config
    }
  }
}
